import { useAppStore } from '../../app/store/useAppStore';
import { Modal } from '../ui/Modal';

export function CameraSettingsSheet() {
  const settings = useAppStore((state) => state.settings);
  const update = useAppStore((state) => state.updateSettings);
  const close = useAppStore((state) => state.closeOverlay);
  const toggle = (key: 'mirrorPreview' | 'showFaceHud' | 'showGpsHud' | 'showPaletteHud') => update({ [key]: !settings[key] });
  return <Modal title="拍照設定" kicker="CAMERA / DISPLAY" onClose={close}>
    <div className="settings-group"><h3>相機</h3>
      <div className="segmented"><button className={settings.facingMode === 'user' ? 'active' : ''} onClick={() => update({ facingMode: 'user' })}>前鏡頭</button><button className={settings.facingMode === 'environment' ? 'active' : ''} onClick={() => update({ facingMode: 'environment' })}>後鏡頭</button></div>
      <label className="setting-row"><span>鏡像預覽<small>輸出會與預覽方向一致</small></span><input type="checkbox" checked={settings.mirrorPreview} onChange={() => toggle('mirrorPreview')} /></label>
    </div>
    <div className="settings-group"><h3>人臉</h3>
      <label className="setting-row"><span>顯示人臉 HUD</span><input type="checkbox" checked={settings.showFaceHud} onChange={() => toggle('showFaceHud')} /></label>
      <label className="field-label">Guest 名稱<input value={settings.guestName} maxLength={18} onChange={(event) => update({ guestName: event.target.value || 'Guest' })} /></label>
    </div>
    <div className="settings-group"><h3>色彩取樣</h3>
      <div className="segmented"><button className={settings.colorSampling === 'full' ? 'active' : ''} onClick={() => update({ colorSampling: 'full' })}>全畫面</button><button className={settings.colorSampling === 'region' ? 'active' : ''} onClick={() => update({ colorSampling: 'region' })}>自訂區域</button></div>
    </div>
    <div className="settings-group"><h3>顯示</h3>
      <label className="setting-row"><span>GPS HUD</span><input type="checkbox" checked={settings.showGpsHud} onChange={() => toggle('showGpsHud')} /></label>
      <label className="setting-row"><span>色票 HUD</span><input type="checkbox" checked={settings.showPaletteHud} onChange={() => toggle('showPaletteHud')} /></label>
    </div>
  </Modal>;
}
